import React from 'react';
import { RecordingMenu } from '../menus/RecordingMenu';
import { SVGContainer } from './SVGContainer';
import { DrawArea } from './DrawArea';
import { ShapeMenu } from '../menus/ShapeMenu';
import modeType from '../../constants/ModeConstants';
import menuType from '../../constants/MenuType';
import { hideMenus } from '../../actions/MenuActions';
import { checkKeyboardCommand } from '../utils/KeyboardShortcuts';
import configuration from '../../constants/Configuration';
import saveManager from '../utils/SaveManager';
import shapeAspectRatioUtils from '../utils/ShapeAspectRatioUtils';
import appParameters from '../utils/AppParameters';
import { ShapeMenuButton } from '../menus/ShapeMenuButton';
import { TextBoxLabel } from '../menus/TextBoxLabel';
import { GroupButton } from '../menus/GroupButton';
import mouseUtils from '../../components/utils/MouseUtils';
import videoUtils from '../../components/utils/VideoUtils';
import selectionManager from '../../components/utils/SelectionManager';
import { VideoEditor } from '../videoEditor/VideoEditor';
import platformDetection from '../utils/PlatformDetection';
import animationManager from '../utils/AnimationManager';
import playController from '../utils/PlayController';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import storeManager from "../../store/StoreManager";

export const Canvas= React.createClass({
    componentDidMount() {
        document.addEventListener('keydown', this.onKeyDown);
        document.addEventListener('keyup', this.onKeyUp);

        setTimeout(function() {
            try {
                if (window.parent) {
                    var iFrame = window.parent.document.getElementById('cartoonist-iframe');

                    if (iFrame && iFrame.contentWindow)
                        iFrame.contentWindow.focus();
                }
            } catch (e) {
                // error
            }
        }.bind(this), 1000);

        if (this.props.mode == modeType.EDITOR) {
            audioEditorUtils.addActionToHistory(); // add first state to UNDO history
            saveManager.initAutoSave();
        }

        videoUtils.init(this.props.dispatch);
    },
    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyDown);
        document.removeEventListener('keyup', this.onKeyUp);
    },
    onKeyDown (e) {
        checkKeyboardCommand(e, this.props.dispatch);
        shapeAspectRatioUtils.checkShift(e);
        selectionManager.checkControl(e);

        var element = document.activeElement;
        var isActiveTextElement = false;

        if (element && (element.className == 'textShapes' || element.className == 'titleInput'))
            isActiveTextElement = true;

        if (playController.isAudioEditorMode() && !isActiveTextElement && (e.keyCode == 37 || e.keyCode == 39)) { // left or right arrows should not scroll in Advanced mode
            e.stopPropagation();
            e.preventDefault();
            return false;
        }

        if (e.keyCode == 8 && platformDetection.isFirefox()) { // is Backspace key and is Firefox
            if (!isActiveTextElement) {
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
        }
    },
    onKeyUp (e) {
        shapeAspectRatioUtils.checkShift(e);
        selectionManager.checkControl(e);
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (animationManager.isAnimationMode())
            return;

        if (appParameters.getMode() == modeType.PLAYER)
            return;

        var target = e.target;

        if (target.id == 'menuButton' || target.parentNode.id == 'menuButton' || target.parentNode.parentNode.id == 'menuButton')
            return;

        if (target.className == 'textShapes')
            return;

        if (storeManager.getState().menu.contextMode == modeType.SIZE_AND_POSITION_CONTEXT)
            return;

        this.props.dispatch(hideMenus([menuType.ALL_MENUS]));
    },
    render() {
        const scaleProperties = this.props.scaleProperties;
        const scaleTransform = `scale(${scaleProperties.scale})`;

        var svgContainerStyle = {
            position: 'absolute',
            transform: scaleTransform,
            WebkitTransform: scaleTransform,
            margin: 0,
            top: scaleProperties.top,
            left: scaleProperties.left,
            maxWidth: configuration.CANVAS_WIDTH,
            maxHeight: configuration.CANVAS_HEIGHT,
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none'
        };

        if (this.props.showVideoEditor)
            svgContainerStyle.display = 'none';

        var elements = [];

        if (appParameters.getMode() != modeType.PLAYER && this.props.mode == modeType.EDITOR && !this.props.showVideoEditor) {
            elements.push(<TextBoxLabel dispatch={this.props.dispatch} scaleProperties={scaleProperties} key={'canvas5'}/>);
            elements.push(<ShapeMenuButton dispatch={this.props.dispatch} scaleProperties={scaleProperties} key={'canvas0'}/>);
            elements.push(<ShapeMenu dispatch={this.props.dispatch} scaleProperties={scaleProperties} key={'canvas1'}/>);
            elements.push(<GroupButton dispatch={this.props.dispatch} scaleProperties={scaleProperties} key={'canvas4'}/>);
            elements.push(<RecordingMenu dispatch={this.props.dispatch} scaleProperties={scaleProperties} mode={this.props.mode} key={'canvas2'}/>);
        }

        var videoBackgroundHolder;
        var videoButtonsHolder;

        videoBackgroundHolder = <VideoEditor scaleProperties={scaleProperties} dispatch={this.props.dispatch} windowWidth={this.props.windowWidth} windowHeight={this.props.windowHeight} accordionWidth={this.props.accordionWidth}/>;

        const videoHolderStyle = {
            position: 'absolute',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            top: 0,
            left: 0
        };

        videoButtonsHolder = <div id='videoHolder' style={videoHolderStyle}/>;

        return (
            <div>
                {videoBackgroundHolder}
                <div id="svgContainer" style={svgContainerStyle} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <SVGContainer dispatch={this.props.dispatch} scaleProperties={scaleProperties}/>
                    <DrawArea dispatch={this.props.dispatch} scaleProperties={scaleProperties} mode={this.props.mode}/>
                </div>
                {videoButtonsHolder}
                {elements}
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/slide/Canvas.js
 **/